import logEventToGraphite from './graphiteReporter';

export const copyLink = (shareLink) => {
    if (!shareLink) {
        throw new SyntaxError('Share link is missing!');
    }
    if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(shareLink);
    } else if (document) {
        const input = document.createElement('input');
        input.style.position = 'fixed';
        input.style.top = '-100vh';

        document.body.appendChild(input);
        input.value = shareLink;
        input.focus();
        input.select();

        const result = document.execCommand('copy');
        if (!result) {
            logEventToGraphite({label: 'social_sharing.error.copy_link'});
        }

        document.body.removeChild(input);
    } else {
        throw new Error('Copying is not supported without either navigator or document');
    }
};



// WEBPACK FOOTER //
// ./src/utils/copyLink.js